import { getNumberProperties } from './getNumberProperties';
/**
 * Returns the complexity of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns ComputedData
 */
export function getComplexity(data) {
    const complexity = getNumberProperties(data, 'Complexity');
    return complexity;
}
//# sourceMappingURL=getComplexity.js.map